import { useAccordion } from "~/lib/accordion"

document.addEventListener('DOMContentLoaded', () => {
	useAccordion('.second-accordion')
})